















































































































import states from '@/assets/states.json';
import Autocomplete from '@/components/form/Autocomplete.vue';
import request from '@/graphql/request';
import { Component, Prop, Vue } from 'vue-property-decorator';

declare var SqPaymentForm: any;

@Component({
  components: {
    Autocomplete,
  },
})
export default class CardInformation extends Vue {
  @Prop() public bus!: Vue;

  public errorMessage = '';
  public givenName = '';
  public familyName = '';
  public addressLine1 = '';
  public addressLine2 = '';
  public addressCity = '';
  public addressState = '';
  public states = states;
  private squareForm: any;

  private squareApplicationId = process.env.VUE_APP_SQUARE_APPLICATION_ID;
  private squareLocationId = process.env.VUE_APP_SQUARE_LOCATION_ID;

  public created() {
    const square = document.createElement('script');
    square.setAttribute('src', 'https://js.squareup.com/v2/paymentform');
    document.head.appendChild(square);
    square.onload = () => this.loadSquareForm();
  }

  public mounted() {
    this.bus.$on('requestPaymentData', () => this.sendPayment());
  }

  public sendPayment() {
    /*
    const billingContact = {
      givenName: this.givenName,
      familyName: this.familyName,
      addressLines: [this.addressLine1, this.addressLine2],
      city: this.addressCity,
      region: this.addressState,
    };
    */
    if (
      !this.givenName ||
      !this
        .familyName /*||
      !billingContact.addressLines.length||
      !billingContact.city ||
      !billingContact.region*/
    ) {
      this.showError('Please fill out all fields.');
    } else {
      this.squareForm.requestCardNonce();
    }
  }

  private showError(message: string) {
    if (message.length) {
      this.bus.$emit('error', message);
    }
  }

  private loadSquareForm() {
    this.squareForm = new SqPaymentForm({
      applicationId: this.squareApplicationId,
      locationId: this.squareLocationId,
      inputClass: 'sq-input',
      autoBuild: false,

      inputStyles: [
        {
          fontSize: '1.2em',
          fontWeight: '100',
          color: '#7a7a7a',
          placeholderColor: '#c2c2c2',
          lineHeight: '1.95em',
          padding: '0 0 0 .35em',
        },
      ],

      cardNumber: {
        elementId: 'sq-card-number',
        placeholder: '1234 1234 1234 1234',
      },
      cvv: {
        elementId: 'sq-cvv',
        placeholder: 'CVV',
      },
      expirationDate: {
        elementId: 'sq-expiration-date',
        placeholder: 'MM/YY',
      },
      postalCode: {
        elementId: 'sq-postal-code',
        placeholder: '78901',
      },

      callbacks: {
        cardNonceResponseReceived: (
          errors: any,
          nonce: string,
          cardData: any,
          billingContact: any
        ) => {
          if (errors && errors.length) {
            this.showError(errors[0].message);
          } else {
            this.bus.$emit('paymentData', {
              token: nonce,
              name: `${this.givenName} ${this.familyName}`,
            });
          }
        },
      },
    });
    this.squareForm.build();
  }
}
